import { useTranslation } from 'react-i18next';

import { usePalletsTypes } from 'constants/palletTypes';
import { useReportTypeLabels } from 'constants/reportTypes';
import { PalletReportDTO } from 'interfaces';

import styles from './DamagedLostByClientPalletsCard.module.css';

type DamagedLostByClientPalletsCardProps = {
   damageLossPalletsData: PalletReportDTO;
};

const DamagedLostByClientPalletsCard = ({
   damageLossPalletsData,
}: DamagedLostByClientPalletsCardProps) => {
   const { t } = useTranslation();

   const { PALLET_TYPE_LABELS } = usePalletsTypes();
   const { REPORT_TYPE_LABELS } = useReportTypeLabels();

   return (
      <div className={styles.container}>
         <div className={styles.dataItem}>
            <span className={styles.label}>{t('damaged_lost_by_client.table.order_id')}</span>
            <span className={styles.value}>#{damageLossPalletsData.orderId}</span>
         </div>
         <div className={styles.dataItem}>
            <span className={styles.label}>{t('damaged_by_client.table.damage_type')}</span>
            <span className={styles.value}>
               {REPORT_TYPE_LABELS[damageLossPalletsData.damagedPallets[0].reportType]}
            </span>
         </div>
         {damageLossPalletsData.damagedPallets.map((damageLossPalletsItem, index) => (
            <div key={index} className={styles.dataItemsGroup}>
               <div>
                  <span className={styles.label}>{t('damaged_by_client.table.pallet_type')}</span>
                  <span className={styles.value}>
                     {PALLET_TYPE_LABELS[damageLossPalletsItem.type]}
                  </span>
               </div>
               <div>
                  <span className={styles.label}>{t('client_orders.table.pallets_amount')}</span>
                  <span className={styles.value}>{damageLossPalletsItem.amount}</span>
               </div>
            </div>
         ))}
      </div>
   );
};

export default DamagedLostByClientPalletsCard;
